import React from "react";
import { Card, Button, Input, Menu, Dropdown, Spin, DatePicker, message } from "antd";
import { Icon } from "@ant-design/compatible";
import { PlusOutlined, SearchOutlined, DownOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";
import Highlighter from "react-highlight-words";
import {
  getTableColumns,
  parseInvoice,
  handleCustomerSearchFieldChange,
  decreaseItemQuantity,
  removeItemFromCart,
  addProductToCart,
  getCartAmount,
  getTotal,
  getCartItems,
} from "./functions";
import CustomDataTable from "../../../../components/CustomDataTable";
import { getAllCustomers } from "../../../../redux/actions/customerActions";
import { getAllBusinessBranches } from "../../../../redux/actions/branchActions";
import { updateProductItemInStore } from "../../../../redux/actions/productActions";
import InvoiceDescription from "./_partials/InvoiceDescription";
import DeleteInvoiceModal from "./_partials/DeleteInvoiceModal";
import SendOptionModal from "../../../../components/SendOptionModal";
import InvoiceForm from "../../../../components/Invoice/InvoiceForm";
import {
  sendInvoiceToCustomerAsMail,
  getDownloadableInvoiceLink,
  getPaymentMessage,
  getAllInvoices,
  getAllInvoicesByDates,
  sendReceipt,
  getDownloadableReceiptLink,
  getAllInvoicesByCustomerName,
  getInvoiceTotals
} from "../../../../redux/actions/invoiceActions";
import numberFormatter from "../../../../utils/numberFormatter";
import "./index.scss";
import strings from "../../../../strings";

const MenuItem = Menu.Item;
const { RangePicker } = DatePicker;

class Invoices extends React.Component {
  state = {
    loading: false,
    loadingInvoice: false,
    loadingTotals: false,
    showDeleteInvoiceModal: false,
    openOptionModal: false,
    showEditInvoice: false,
    cartList: [],
    invoices: [],
    allInvoices: [],
    isReceipt: false,
    invoice: {},
    total: 0,
    current: 1,
    defaultPageSize: 10,
    pageSize: 10,
    filterValue: "",
    totalPaidInvoices: 0,
    totalUnpaidInvoices: 0,
    isSelectedDate: false,
    begin: null,
    end: null,
    customer_name: null
  };

  handleCustomerSearchFieldChange = handleCustomerSearchFieldChange.bind(this);
  decreaseItemQuantity = decreaseItemQuantity.bind(this);
  removeItemFromCart = removeItemFromCart.bind(this);
  addProductToCart = addProductToCart.bind(this);
  getCartAmount = getCartAmount.bind(this);
  getTotal = getTotal.bind(this);
  parseInvoice = parseInvoice.bind(this);

  async componentDidMount() {
    // Check for URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const customerId = urlParams.get('customer_id');
    const status = urlParams.get('status');
    
    // Load customers first
    await this.props.getAllCustomers();
    this.props.getAllBusinessBranches();
    // REMOVED: fetchAllInvoices() - was loading 10M invoices!
    // Fetch totals from backend instead
    this.fetchInvoiceTotals();
    
    if (customerId && status === 'unpaid') {
      // Find customer and set filter
      const customer = this.props.customers.find(c => c.id === parseInt(customerId));
      
      if (customer) {
        const customerName = `${customer.first_name || ''} ${customer.last_name || ''}`.trim();
        
        this.setState({ 
          customer_name: customerName,
          filterValue: 'unpaid'
        });
        this.handleGetInvoiceByCustName(customerName);
      } else {
        this.fetchInvoices();
      }
    } else {
      this.fetchInvoices();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      // invoices: nextProps.invoices,
    });
    this.handleLoading(false);
  }

  fetchInvoices = (
    current = this.state.current,
    pageSize = this.state.pageSize
  ) => {
    this.setState({ loading: true });
    this.props.getAllInvoices(current, pageSize).then((res) =>
      this.setState({
        loading: false,
        total: Number(res.headers.total || 0),
        current: Number(res.headers.page),
        pageSize: Number(res.headers["per-page"]),
        invoices: res.data
      })
    );
  };

  fetchInvoicesByDate = (
    current = this.state.current,
    pageSize = this.state.pageSize,
    begin = this.state.begin,
    end = this.state.end
  ) => {
    this.setState({ loading: true });
    this.props
    .getAllInvoicesByDates(current, pageSize, begin, end)
    .then((res) =>
      this.setState({
        loading: false,
        total: Number(res.headers.total || 0),
        current: Number(res.headers.page),
        pageSize: Number(res.headers["per-page"]),
        invoices: res.data
      })
    )
    .catch(() => {
      message.error(strings.errorFetchingRecord);
    });
    
  };

  // REMOVED: fetchAllInvoices - was loading 10 MILLION invoices!
  // This caused massive server resource consumption
  // Totals are now fetched from backend endpoint instead

  fetchInvoiceTotals = (params = {}) => {
    this.setState({ loadingTotals: true });
    this.props
      .getInvoiceTotals(params)
      .then((res) => {
        if (res && res.data) {
          const { paid, unpaid } = res.data;
          this.setState({
            totalPaidInvoices: paid?.total || 0,
            totalUnpaidInvoices: unpaid?.total || 0,
            loadingTotals: false,
          });
        }
      })
      .catch((err) => {
        this.setState({ loadingTotals: false });
      });
  };

  toggleDescriptionModal = () => {
    this.setState({
      showDescriptionModal: !this.state.showDescriptionModal,
    });
  };

  toggleDeleteInvoiceModal = () => {
    this.setState({
      showDeleteInvoiceModal: !this.state.showDeleteInvoiceModal,
    });
  };

  toggleSendOptionModal = () => {
    const { invoice } = this.state;
    this.setState({
      openOptionModal: !this.state.openOptionModal,
      isReceipt: invoice.status === "paid" ? true : false,
    });
  };

  toggleEditInvoiceModal = (value) => {
    if (value) {
      this.setState({
        showEditInvoice: true,
      });
    } else {
      this.setState({
        showEditInvoice: !this.state.showEditInvoice,
      });
    }
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`${strings.search} ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {strings.search}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, confirm, dataIndex)}
          size="small"
          style={{ width: 90 }}
        >
          {strings.reset}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.productSearchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ""}
      />
    ),
  });

  handleGetInvoiceByCustName = (
    customer_name,
    current = this.state.current,
    pageSize = this.state.pageSize
  ) => {
    this.setState({ loading: true });
    this.props
    .getAllInvoicesByCustomerName(customer_name, current, pageSize)
    .then((res) =>{
      this.setState({
        loading: false,
        total: Number(res.headers.total || 0),
        current: Number(res.headers.page),
        pageSize: Number(res.headers["per-page"]),
        invoices: res.data
      })
    })
    .catch((err) => {
      message.error(strings.errorFetchingRecord);
      this.setState({ loading: false })
    });
  }
  
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    if(dataIndex === "customerName"){
      this.setState({ productSearchText: selectedKeys[0], customer_name: selectedKeys[0]  });
      return this.handleGetInvoiceByCustName(selectedKeys[0])
    }
    
    confirm();
    this.setState({ productSearchText: selectedKeys[0] });
  };

  handleReset = (clearFilters, confirm, dataIndex) => {
    if(dataIndex === "customerName"){
      this.setState({ productSearchText: "", customer_name: null  });
      return this.fetchInvoices()
    }
    clearFilters();
    confirm();
    this.setState({ productSearchText: "" });
  };

  updateFilterValue = filterValue => this.setState({ filterValue: filterValue });

  handleDurationChange = (duration, ...rest) => {
    const { current, pageSize, begin, end, selectedBranchId } = this.state;
    this.updateFilterValue("");

    if (duration) {
      const [begin, end] = duration;
      const beginStr = begin.format().split("T")[0];
      const endStr = end.format().split("T")[0];
      
      this.setState({
        loading: true,
        begin: beginStr,
        end: endStr
      });
      
      this.fetchInvoicesByDate(1, pageSize, beginStr, endStr);
      
      // Fetch totals with date range
      const totalsParams = { from: beginStr, to: endStr };
      if (selectedBranchId) {
        totalsParams.business_branch_id = selectedBranchId;
      }
      this.fetchInvoiceTotals(totalsParams);
      
    } else if (!duration) {
      this.setState({
        loading: true,
        begin: null,
        end: null
      });
      
      this.fetchInvoices(1, pageSize);
      
      // Fetch totals without date range
      const totalsParams = {};
      if (selectedBranchId) {
        totalsParams.business_branch_id = selectedBranchId;
      }
      this.fetchInvoiceTotals(totalsParams);
      
    } else if (!begin || !end) {
      message.error(
        `${strings.pleaseEnterAValid} ${!begin ? strings.begin : strings.end} ${
          strings.date
        }.`
      );
    }
  };

  handleLoading = (value) => {
    this.setState({
      invoiceLoading: value,
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { begin, end, customer_name } = this.state;
    
    // Handle status filter changes
    if (filters && filters.status !== undefined) {
      // If status filter is cleared or changed, clear the URL-based filterValue
      if (!filters.status || filters.status.length === 0) {
        this.setState({ filterValue: null });
      }
    }
    
    if (current !== this.state.current || pageSize !== this.state.pageSize){
      if(customer_name){
        this.handleGetInvoiceByCustName(customer_name, current, pageSize)
      }else if(begin && end ){
        this.fetchInvoicesByDate(current, pageSize, begin, end)
      }else{
        this.fetchInvoices(current, pageSize);
      }
    }
  };

  render() {
    const {
      loading,
      loadingInvoice,
      showDescriptionModal,
      showDeleteInvoiceModal,
      invoice,
      openOptionModal,
      showEditInvoice,
      cartList,
      invoices,
      customerName,
      customerValue,
      isReceipt,
      defaultPageSize,
      current,
      total,
      pageSize,
      // allInvoices and allInvoicesLoading removed - using paginated data instead
      end,
      begin
    } = this.state;

    const {
      sendInvoiceToCustomerAsMail,
      getDownloadableInvoiceLink,
      user,
      customers,
      sendReceipt,
      getDownloadableReceiptLink,
      products
    } = this.props;

    let columns = getTableColumns.call(this);
    const totalInvoices = this.state.total;
    
    // Apply filters if set from URL parameters
    if (this.state.filterValue === 'unpaid' || this.state.customer_name) {
      columns = columns.map(col => {
        if (col.dataIndex === 'status' && this.state.filterValue === 'unpaid') {
          return {
            ...col,
            filteredValue: ['unpaid', 'partial']
          };
        }
        if (col.dataIndex === 'customerName' && this.state.customer_name) {
          return {
            ...col,
            filteredValue: [this.state.customer_name]
          };
        }
        return col;
      });
    }

    const acceptedHeaders = [
      {
        label: "Invoice ID",
        key: "number",
      },
      {
        label: "Customer",
        key: "customerName",
      },
      {
        label: "Status",
        key: "status",
      },
      {
        label: "Total",
        key: "subtotal",
      },
      {
        label: "Amount Paid",
        key: "amountPaid",
      },
      {
        label: "Amount Due",
        key: "amountDue",
      },
      {
        label: "Staff Username",
        key: "staff_username",
      },
      {
        label: "Created Date",
        key: "createdDate",
      },
      {
        label: "Date Paid",
        key: "paidDate",
      },
      {
        label: "Reference",
        key: "payment_reference",
      },
      {
        label: "Payment Message",
        key: "payment_message",
      },
    ];

    return (
      <main>
        <Card
          title={strings.invoices}
          loading={loading}
          extra={
            (user.role_id === 1 ||
              user.role.id === 2 ||
              user.role.id === 3) && (
              <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                <div>
                  <span style={{ margin: "0 10px" }}>{strings.invoiceFrom}:</span>
                  <RangePicker
                    placeholder={[strings.startDate, strings.endDate]}
                    onChange={this.handleDurationChange} />
                </div>
                <Dropdown
                  overlay={
                    <Menu>
                      <MenuItem key="1">
                        <CSVLink
                          data={this.parseInvoice(invoices)}
                          headers={acceptedHeaders}
                          filename={"invoiceList.csv"}
                          target="_blank"
                          style={{ marginLeft: "10px" }}
                        >
                          <Button> Download Invoices (Current Page)</Button>
                        </CSVLink>
                      </MenuItem>
                    </Menu>
                  }
                >
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    size="default"
                    onClick={() => {
                      this.props.getPaymentMessage();
                      this.toggleDescriptionModal();
                    }}
                  >
                    {strings.paymentMessage} <DownOutlined />
                  </Button>
                </Dropdown>
              </div>
            )
          }
        >
          <section className="invoices-table mt-40">
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <h5>
                {strings.totalInvoices}: {totalInvoices}
              </h5>
              <span
                style={{
                  display: "flex",
                  width: "auto",
                  minWidth: "40%",
                  justifyContent: "space-between",
                }}
              >
                <h5 style={{ marginRight: "10px" }}>
                  {strings.totalPaidInvoices}:{" "}
                  {this.state.loadingTotals ? (
                    <Spin size="small" />
                  ) : (
                    numberFormatter(this.state.totalPaidInvoices)
                  )}
                </h5>
                <h5>
                  {strings.totalUnpaidInvoices}:{" "}
                  {this.state.loadingTotals ? (
                    <Spin size="small" />
                  ) : (
                    numberFormatter(this.state.totalUnpaidInvoices)
                  )}
                </h5>
              </span>
            </div>

            <CustomDataTable
              columns={columns}
              dataSource={this.parseInvoice(invoices)}
              loading={loadingInvoice}
              pagination={{ defaultPageSize: pageSize, current, total, pageSize }}
              onChange={this.handleTableChange}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    if (!event.target.classList.contains("fa-ellipsis-h")) {
                      // console.log("item", record.items);
                      this.setState(
                        {
                          invoice: {
                            ...record,
                            hasDiscount: record.has_discount,
                            discountAmount: record.discount_amount,
                          },
                          // cartList: record.items,
                          cartList: getCartItems(record.items),
                          customerName: `${record.customer.first_name} ${
                            record.customer.last_name || ""
                          }`,
                          customerValue: record.customer.user_id,
                        },
                        () => {
                          this.toggleEditInvoiceModal("open");
                        }
                      );
                    }
                  },
                };
              }}
            />
          </section>
        </Card>
        {showDescriptionModal ? (
          <InvoiceDescription
            showModal={showDescriptionModal}
            closeModal={this.toggleDescriptionModal}
          />
        ) : null}

        {showDeleteInvoiceModal ? (
          <DeleteInvoiceModal
            showModal={showDeleteInvoiceModal}
            closeModal={this.toggleDeleteInvoiceModal}
            invoice={invoice}
          />
        ) : null}

        <SendOptionModal
          cancel={this.toggleSendOptionModal}
          openOptionModal={openOptionModal}
          invoice={invoice}
          sendInvoiceToCustomerAsMail={sendInvoiceToCustomerAsMail}
          getDownloadableInvoiceLink={getDownloadableInvoiceLink}
          user={user}
          isReceipt={isReceipt}
          saleId={invoice.id}
          sendReceipt={sendReceipt}
          getDownloadableReceiptLink={getDownloadableReceiptLink}
          getAllInvoices={this.props.getAllInvoices}
          cartList={this.state.cartList}
        />

        {showEditInvoice && (
          <InvoiceForm
            selectedCustomer={customerName}
            cartList={cartList}
            addProductToCart={this.addProductToCart}
            removeItemFromCart={this.removeItemFromCart}
            reduceItemFromCart={this.decreaseItemQuantity}
            addNewProductToCart={this.addProductToCart}
            handleShowBulkQuantityModal={() => {}}
            toggleShowInvoicePrompt={() => {}}
            type="edit"
            user={user}
            getCartTotalAmount={this.getCartAmount}
            invoicePrompt={true}
            visible={showEditInvoice}
            toggleShowCashForm={() => {}}
            onCancel={this.toggleEditInvoiceModal}
            customerValue={customerValue}
            customerName={customerName}
            onCustomerSearch={this.handleCustomerSearchFieldChange}
            customers={customers}
            cleanupSelectCustomerDropdown={() => {}}
            handleSaveInvoiceDone={() => {}}
            invoiceId={invoice.id}
            invoice={invoice}
            handleLoading={this.handleLoading}
            customer={invoice.customer}
            toggleDeleteInvoiceModal={this.toggleDeleteInvoiceModal}
            hasDiscount={invoice && invoice.hasDiscount}
            discountAmount={invoice && invoice.discountAmount}
            fetchInvoices={() => begin && end ? this.fetchInvoicesByDate() : this.fetchInvoices()}
          />
        )}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  invoices: state.invoice.allInvoices,
  user: state.auth.user,
  error: state.error,
  customers: state.customer.allCustomers,
  allBranches: state.branch.allBranches,
  products: state.product.allProducts,
});

export default connect(mapStateToProps, {
  getAllInvoices,
  sendInvoiceToCustomerAsMail,
  getDownloadableInvoiceLink,
  getAllCustomers,
  updateProductItemInStore,
  getPaymentMessage,
  sendReceipt,
  getDownloadableReceiptLink,
  getAllBusinessBranches,
  getAllInvoicesByDates,
  getAllInvoicesByCustomerName,
  getInvoiceTotals
})(Invoices);
